<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo Tag na parte cadastro de Status do Menu Plano  ==================------->
      <vs-alert icon="warning" active="true" color="warning" class="my-5">
        <p class="mb-2">
          Para se cadastrar um valor para todas as cidades do estado, basta
          selecionar somente o estado
        </p>
        <p>
          caso tenha um valor especifico para a cidade, esse valor vai
          prevalecer sobre o valor do estado
        </p>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full mb-6">
          <span>Estado</span>
          <v-select
            :options="estados"
            class="w-full"
            label="label"
            name="Estado"
            id="Estado"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Estado')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'Estado')
            "
            @input="
              buscaDadosSelectsCidades(
                'domMunicipios',
                'cidades',
                'nomeCidade',
                'idCidade'
              ),
                selecionaEstado()
            "
            v-model="estado"
          ></v-select>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-6">
          <span>Cidade</span>
          <v-select
            class="w-full"
            :options="cidades"
            label="label"
            name="Cidade"
            id="Cidade"
            v-model="cidade"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <span>Peso Inicial (em gramas)</span>
          <vs-input
            class="w-full"
            name="Peso Inicial"
            id="Peso Inicial"
            type="number"
            v-model="formCadastro.pesoInicial"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Peso Inicial'
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Peso Inicial'
              )
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <span>Peso Final (em gramas)</span>
          <vs-input
            class="w-full"
            name="Peso Final"
            id="Peso Final"
            type="number"
            v-model="formCadastro.pesoFinal"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Peso Final'
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Peso Final'
              )
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Valor Frete Estimado</span>
          <vs-number
            style="padding: 10px"
            class="w-full vs-inputx vs-input--input medium"
            name="Valor Frete Estimado"
            id="valor Frete Estimado"
            v-model="formCadastro.valorFreteEstimado"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Nome Produto'
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Nome Produto'
              )
            "
            v-bind="money"
          ></vs-number>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idTabelaFrete == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "../../../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../../../services";
import BotaoSubmit from "../../../../components/BotaoSubmit";
import utilsList from "../../../../utils/list";
import { Money } from "v-money";
export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    contadorRender: {
      type: Number,
    },
  },

  watch: {
    dados(value) {
      this.preencheForm();
    },
    contadorRender(value) {
      this.preencheForm();
    },
    cidade(newValue) {
      if (newValue) {
        this.formCadastro.cidade = newValue.label;
      }

      if (!newValue) {
        this.formCadastro.cidade = "";
        this.cidade = "";
      }
    },
    estado(value) {
      if (value) {
        this.formCadastro.estado = value.label;
      }

      if (!value) {
        this.formCadastro.estado = "";
        this.estado = "";

        this.cidades = [];
        this.cidade = "";
        this.formCadastro.cidade = "";
      }
    },
  },
  data() {
    return {
      utilsList,
      money: {
        decimal: ".",
        thousands: "",
        suffix: "",
        precision: 2,
        masked: true,
      },
      files: new FormData(),
      icone: null,
      activePromptValor: false,
      aguardeCadastro: false,
      valorBeneficio: 0,
      situacoes: ["Ativo", "Inativo"],
      estados: [],
      cidades: [],
      estado: null,
      cidade: null,
      languages: lang,
      funcoesValicao: null,
      formCadastro: {
        idTabelaFrete: null,
        estado: "",
        cidade: "",
        pesoInicial: null,
        pesoFinal: null,
        valorFreteEstimado: 0,
        status: true,
        icone: null,
      },
    };
  },
  methods: {
    formataValor(valor) {
      var retorno = this.$options.filters.currency(valor);
      return retorno;
    },
    preencheForm() {
      this.estado = null;
      this.cidade = null;
      if (this.dados.idTabelaFrete) {
        this.formCadastro.idTabelaFrete = this.dados.idTabelaFrete;
        this.formCadastro.estado = this.dados.estado;
        this.formCadastro.cidade = this.dados.cidade;

        if (this.dados.estado) {
          this.estado = this.dados.estado;
        }
        if (this.dados.cidade) {
          this.cidade = this.dados.cidade;
        }

        if (this.dados.cidade == null) {
          this.cidade = "";
        }

        if (this.dados.estado == null) {
          this.estado = "";
        }
        this.formCadastro.pesoInicial = this.dados.pesoInicial;
        this.formCadastro.pesoFinal = this.dados.pesoFinal;
        this.formCadastro.valorFreteEstimado = this.dados.valorFreteEstimado;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
      } else {
        this.resetForm();
      }
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (!this.estado) {
        return;
      }
      console.log(this.estado);

      this.$vs.loading();
      this[array] = [];

      service
        .getAll("g", {}, `${model}/list/idUf/${this.estado.id}`)
        .then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });

          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    selecionaEstado() {
      if (!this.estado) return;

      var aux = this.estados.find((x) => x.id == this.estado.id);
      this.formCadastro.estado = aux.label;
    },

    onSubmit() {
      var action = "Atualizar/" + this.formCadastro.idTabelaFrete;
      var metodo = "put";
      var msgRetorno = "Dados Atualizados com sucesso";
      if (!this.formCadastro.idTabelaFrete) {
        action = "Adicionar";
        metodo = "post";
        msgRetorno = "Tabela Adicionado com sucesso";
      }
      var objSend = { ...this.formCadastro };

      console.log(objSend);

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service[metodo]("TabelasFrete", action, objSend)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });
              this.$emit("concluido");
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list`).then((res) => {
        res.data.forEach((element) => {
          console.log(element);
          if (element.deletedAt == null)
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
        this[array].sort(function (a, b) {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
        this[array].unshift({ id: null, label: "Selecione" });
      });
    },
    resetForm() {
      this.TagsBeneficios = [];
      this.formCadastro = {
        idTabelaFrete: null,
        descricao: null,
        status: true,
        icone: null,
      };
    },
    onReset(evt) {
      this.$emit("cancel");

      this.resetForm();
    },
  },
  created() {
    this.buscaDadosSelects("domUf", "estados", "nomeUf", "idUf");
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
    "vs-number": Money,
  },
};
</script>
<!------------ END SCRIPT ------------>
